export default __webpack_public_path__ + "acfc3690bc2c53259ee0d7ecb54ff539.png";